import React, { useEffect, useState } from 'react';
import axios from 'axios'; // Import axios
import './Qualification.css';
import QualificationCard from './QualificationCard';

function Qualification() {
  const [education, setEducation] = useState([]);
  const [experience, setExperience] = useState([]);
  const [error, setError] = useState(null); // To handle errors if any

  useEffect(() => {
    // Fetch the qualification data using axios
    axios.get('/data/data.json') // Assuming you place the JSON in the public/data folder
      .then(response => {
        console.log(response.data);
        const { education, experience } = response.data;
        setEducation(education);
        setExperience(experience);
      })
      .catch(err => {
        console.error('Error fetching the qualification data:', err);
        setError('Failed to load qualification data');
      });
  }, []);

  return (
    <section className="qualification section">
      <h2 data-heading="My Journey" className="section__title">Qualification</h2>

      {error ? (
        <p className="error" style={{textAlign: 'center'}}>{error}</p> // Display an error message if fetching fails
      ) : (
        <div className="qualification__container container grid">
          <div className="education">
            <h3 className="qualification__title">
              <i className="uil uil-graduation-cap"></i> Education
            </h3>
            <div className="timeline">
              {education.map((edu, index) => (
                <QualificationCard
                  key={index}
                  title={edu.title}
                  location={edu.location}
                  description={edu.description}
                  date={edu.date}
                />
              ))}
            </div>
          </div>

          <div className="experience">
            <h3 className="qualification__title">
              <i className="uil uil-suitcase"></i> Experience
            </h3>
            <div className="timeline">
              {experience.map((exp, index) => (
                <QualificationCard
                  key={index}
                  title={exp.title}
                  location={exp.location}
                  description={exp.description}
                  date={exp.date}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Qualification;
